<template>
  <a-list
    itemLayout="horizontal"
    :dataSource="data"
  >
    <a-list-item slot="renderItem" slot-scope="item">
      <router-link
        :to="{ name: 'assessment-details', params: { 'assessmentId': item.id } }"
        slot="actions">
        View Assessment
      </router-link>
      <a-list-item-meta>
        <router-link
        :to="{ name: 'assessment-details', params: { 'assessmentId': item.id } }"
        slot="title">
          {{item.title.rendered}}
        </router-link>
      </a-list-item-meta>
    </a-list-item>
  </a-list>
</template>

<script>
export default {
  name: 'assessment-list-single',
  props: [
    'data',
  ],
};
</script>
